
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import AlertBox from "@/components/Reusable/CustomInputs/AlertBox.vue";
import { configStore } from "@/store/store-accessor";

type ProAlertBoxOptions = {
  content?: string;
  feature?: string;
};

@Component({
  components: { AlertBox }
})
export default class ProOnlyAlertBox extends Vue {
  @Prop()
  options!: ProAlertBoxOptions;

  get isFreeMode() {
    return configStore.subscriptionMode === "free";
  }

  get urlWithUtm() {
    return `https://breakdance.com/?utm_source=free-version&utm_medium=free-version&utm_campaign=${this.options.feature}`;
  }
}
